const absCompare = (currStart, nextStart, currEnd, nextEnd) => {
  if (currStart > nextStart) {
    return 1;
  } else if (currStart < nextStart) {
    return -1;
  } else if (currStart === nextStart) {
    if (currEnd < nextEnd || !currEnd) {
      return -1
    }
    return 0;
  }
}

const colComparator = (curr, next) => {
  const currValueStr = curr ? curr.toString() : '0';
  const nextValueStr = next ? next.toString() : '0';

  let currStart, currEnd, nextStart, nextEnd;
  const separator = '-';
  if (currValueStr.includes(separator)) {
    currEnd = Number(currValueStr.split(separator)[1]);
    nextEnd = Number(nextValueStr.split(separator)[1]);
  }
  currStart = Number(currValueStr.split(separator)[0]);
  nextStart = Number(nextValueStr.split(separator)[0]);

  return absCompare(currStart, nextStart, currEnd, nextEnd)
};

const widthColComparator = (curr, next) => {
  const currValueStr = curr ? curr.toString() : '0';
  const nextValueStr = next ? next.toString() : '0';

  let currStart, currEnd, nextStart, nextEnd;
  const rangeSeparator = '-', averageSeparator = '/';

  const parseRangeStrValue = (valueStr) => {
    let start, end;
    if (valueStr.includes(rangeSeparator)) {
      start = Number(valueStr.split(rangeSeparator)[0]);
      end = Number(valueStr.split(rangeSeparator)[1]);
    } else if (valueStr.includes(averageSeparator)) {
      start = Number(valueStr.split(averageSeparator)[1]); // 12 / 1000, 1000 - average width
      end = Number(valueStr.split(averageSeparator)[0]);
    } else if (!valueStr.includes(rangeSeparator) && !valueStr.includes(averageSeparator)) {
      start = Number(valueStr);
    }

    return [start, end];
  }

  [currStart, currEnd] = parseRangeStrValue(currValueStr);
  [nextStart, nextEnd] = parseRangeStrValue(nextValueStr)

  return absCompare(currStart, nextStart, currEnd, nextEnd);
};

export const addComparatorsToCol = (col) => {
  if (col.field === 'thickness' || col.field === 'length' || col.field === 'per_m3_price') {
    col.comparator = colComparator;
  } else if (col.field === 'width') {
    col.comparator = widthColComparator;
  }
  return col;
};

export const isParentNode = (node) => {
  return node.childrenAfterGroup;
}

export const getGridNodes = (grid) => {
  const data = [];
  grid.api.forEachNode(node => {
    data.push(node);
  });
  return data;
}

export const getGridGroups = (grid) => {
  return getGridNodes(grid).filter(node => !node.data)
}



// WEBPACK FOOTER //
// ./src/helpers/grid-helpers.js